import React from 'react';

import BotonGhostUnidad from '../BotonGhostUnidad/index';
import CardVideoUnidad from '../CardVideoUnidad/index';

import './css/styles.css';

class PanelLaUniadVideo extends React.Component{
    render(){
        return(
            <section className="background_panel_unidad_principal">
                
                    <BotonGhostUnidad text="unidad de investigación periodística"
                                      boxLeft="s12 m2"
                                      boxCenter="s12 m8"
                                      boxRight="s12 m2"/>
                    <CardVideoUnidad />
                
            </section>
        );
    }
}

export default PanelLaUniadVideo;